export default __webpack_public_path__ + "d2c9ba39f8c7867bec5221e26a6922c1.ttf";